import { useAppSelector } from 'app/hooks';
import React, { useMemo, useState } from 'react';
import { Virtuoso } from 'react-virtuoso';
import { useGetNotificationsQuery } from '../notificationApi';
import { LIMIT, selectNotifications, selectTotal } from '../slice';
import MessageCard from './MessageCard';
import { INotificationResponse } from '../types';

interface IProps {
  closeNotificationModal: () => void;
}

const sortNotificationByLatestDate = (notifications: INotificationResponse[]) => {
  return [...notifications].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  );
};

const NotificationList: React.FC<IProps> = ({ closeNotificationModal }) => {
  const notifications = useAppSelector(selectNotifications);
  const total = useAppSelector(selectTotal);
  const [offset, setOffset] = useState(0);
  useGetNotificationsQuery({ offset, limit: LIMIT });
  const sortedNotifications = useMemo(
    () => sortNotificationByLatestDate(notifications),
    [notifications]
  );

  const loadNext = () => {
    if (total > notifications.length) {
      setOffset(notifications.length);
    }
  };

  return (
    <div style={{ flex: 1 }}>
      <Virtuoso
        style={{ height: '250px' }}
        data={sortedNotifications}
        endReached={loadNext}
        /* eslint-disable-next-line react/no-unstable-nested-components */
        itemContent={(_index, data) => (
          <MessageCard
            key={data.id}
            cypressAttribute="notification-message-card"
            closeNotificationModal={closeNotificationModal}
            {...data}
          />
        )}
      />
    </div>
  );
};

export default NotificationList;
